module.exports = __webpack_public_path__ + "img/Accountor-22-lowres.0926b979.jpg";